// Shared by world.ts and levels.ts
export const P = 15; // the pea's radius
